<template>
  <div class="carousel-component-wrap">
    <div class="left-scroller-btn" @click="leftScrolling">
      <span class="fas fa-chevron-left"></span>
    </div>
    <div class="carousel-content">
      <div>
        <div
          v-for="(i, category) in getCategories()"
          :key="i"
          @click="updateSelection(category)"
          class="carousel-item"
        >
          <span>{{ category }}</span>
        </div>
      </div>
    </div>
    <div class="right-scroller-btn" @click="rightScrolling">
      <span class="fas fa-chevron-right"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "filter-carousel",
  props: {
    offers: Array,
  },
  data: () => {
    return {
      categories: [],
      selectedCategory: "",
    };
  },
  methods: {
    getCategories: function () {
      this.offers.forEach((offer) => {
        if (this.categories.indexOf(offer.category) < 0)
          this.categories.push(offer.category);
      });
      return this.categories;
    },
    updateSelection: function (category) {
      let sameLast = this.selectedCategory == category;
      this.$emit("filter", sameLast ? "" : category);
      this.selectedCategory = sameLast ? "" : category;
    },
    leftScrolling: function () {
      let carouselContent = document.querySelector(".carousel-content");
      carouselContent.scroll({
        left: carouselContent.scrollLeft - carouselContent.offsetWidth / 2,
        behavior: "smooth",
      });
    },
    rightScrolling: function () {
      let carouselContent = document.querySelector(".carousel-content");
      carouselContent.scroll({
        left: carouselContent.scrollLeft + carouselContent.offsetWidth / 2,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.carousel-component-wrap {
  display: flex;
}

.carousel-content {
  flex: 1;
  width: calc(100% - 40px);
  overflow: auto;
}

.carousel-content > div {
  display: flex;
  font-size: 13px;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.carousel-content::-webkit-scrollbar {
  display: none;
}

.carousel-content::-webkit-scrollbar-track {
  display: none;
}

.carousel-content::-webkit-scrollbar-thumb {
  display: none;
}

.carousel-item {
  padding: 0px 30px;
  cursor: pointer;
}

.carousel-item span {
  height: 28px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.carousel-item.active span {
  border-bottom: 1.2px solid;
}

.left-scroller-btn,
.right-scroller-btn {
  cursor: pointer;
  opacity: 0.6;
  height: inherit;
  display: flex;
  align-items: center;
  width: 20px;
}

.right-scroller-btn {
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// market-filter.vue?7547616b